import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Link} from 'react-router-dom'
import {Button} from 'antd'
import SaveModal from './Modals/Save'
import SampleModal from './Modals/Sample'
import CreateAndRunModal from './Modals/CreateAndRun'

import style from './controls.sass'

@inject('store') @observer
class Controls extends Component {
  state = {
    saveModal: false,
    sampleModal: false,
    createAndRunModal: false
  }
  openSaveModal = () => {
    if (this.props.store.algo.validateMain()) {
      this.setState({saveModal: true})
    }
  }
  runBacktest = () => {
    const {algo, permissions} = this.props.store
    let func
    if (this.props.editing) {
      if (algo.single.data.has_tutorial) {
        func = () => this.setState({sampleModal: true})
      } else {
        func = () => algo.updateAndRun()
      }
    } else {
      func = () => this.setState({createAndRunModal: true})
    }
    permissions.wrap('lab.backtest.run', func)
  }
  closeSaveModal = () => {
    this.setState({saveModal: false})
  }
  closeSampleModal = () => {
    this.setState({sampleModal: false})
  }
  closeCreateAndRunModal = () => {
    this.setState({createAndRunModal: false})
  }
  updateAlgo = () => {
    this.props.store.algo.single.update()
  }
  getContent = () => {
    const {editing} = this.props
    const {algo, permissions} = this.props.store
    const {data, submitEnabled} = algo.single
    const activePaperTrading = data.has_active_trading_sessions
    const backtestRunning = !!data.backtest?.is_currently_running

    if (activePaperTrading) {
      return(
        <h4>
          You can&apos;t change an algo while you have active trading sessions for it.
        </h4>
      )
    } else if (backtestRunning) {
      return(
        <h4>
          You can&apos;t change an algo while its backtest is running.
        </h4>
      )
    } else {
      return(
        <div styleName='buttons'>
          <div>
            {!algo.single.data.has_tutorial && editing &&
              <Button
                type='primary'
                icon='save'
                onClick={() => permissions.wrap('lab.algo.update', this.updateAlgo)}
                disabled={!submitEnabled}
                className={permissions.checkUpgrade('lab.algo.update') ? 'upgrade-ribbon' : ''}
                styleName='btn-save'
              >
                Save
              </Button>
            }
            <Button
              type='primary'
              icon='save'
              onClick={() => permissions.wrap('lab.algo.create', this.openSaveModal)}
              disabled={!submitEnabled}
              className={permissions.checkUpgrade('lab.algo.create') ? 'upgrade-ribbon' : ''}
              styleName='btn-save'
            >
              {editing ? 'Save as...' : 'Save'}
            </Button>
            <Link to='/manager'>
              <Button
                type='default'
                icon='close'
              >
                Cancel
              </Button>
            </Link>
          </div>
          <Button
            type='primary'
            icon='thunderbolt'
            onClick={this.runBacktest}
            disabled={!submitEnabled}
            className={permissions.checkUpgrade('lab.backtest.run') ? 'upgrade-ribbon' : ''}
            styleName='btn-run'
          >
            Run Backtest
          </Button>
        </div>
      )
    }
  }
  render() {
    return(
      <div styleName='wrapper'>
        <SaveModal
          visible={this.state.saveModal}
          close={this.closeSaveModal}
        />
        <SampleModal
          visible={this.state.sampleModal}
          close={this.closeSampleModal}
        />
        <CreateAndRunModal
          visible={this.state.createAndRunModal}
          close={this.closeCreateAndRunModal}
        />
        {this.getContent()}
      </div>
    )
  }
}

export default Controls
